import React from "react";

function StockViewTabs({ activeView, items, onChange, ariaLabel }) {
  return (
    <div className="stock-view-tabs" role="tablist" aria-label={ariaLabel}>
      {items.map((item) => {
        const active = activeView === item.value;
        return (
          <button
            key={item.value}
            type="button"
            role="tab"
            aria-selected={active}
            className={active ? "stock-view-tab active" : "stock-view-tab"}
            onClick={() => onChange(item.value)}
          >
            <span>{item.label}</span>
            {item.count !== undefined && item.count !== null ? (
              <span className="stock-view-tab__count">{item.count}</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}

export default StockViewTabs;
